
const ImageLinkBtn = ({ image, alt, width, height }) => {
  return (
    <img 
      src={image} 
      alt={alt} 
      style={{ 
        cursor: 'pointer', 
        width: width || '50px',
        height: height || 'auto'
      }} 
    />
  );
}

export default ImageLinkBtn;
